import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };

export function getUserSettingsSchema(t: MessageFormatter) {
  return z.object({
    name: z.string().trim().min(1, t(requiredMsg)),
    surname: z.string().trim().min(1, t(requiredMsg)),
    language: z.string(),
  });
}

export type UserSettingsValues = z.infer<ReturnType<typeof getUserSettingsSchema>>;
